module.exports = __webpack_public_path__ + "img/bg_xdcj.8d8a4120.svg";